import {action} from '../utils/actionCreator'
import * as actions from '../constants'

export const successFetchLightCapabilityData = data => action(actions.SUCCESS_FETCH_LIGHT_CAPABILITY_DATA, { data })